import { css } from '@emotion/react';
import { styled } from '@mui/material';
import { colors } from '../../../../../theme/colors';

export const Background = styled('div')`
  background: ${({ theme }) => theme.gradients.primary};
  min-height: 100%;
`;

export const mainContentWrapperCss = css`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  max-height: 100%;
`;

export const headerWrapperCSS = css`
  background: white;
  border-bottom: 2px ${colors.neutral[40]} solid;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1rem 3rem;
`;

export const statusWrapperCss = css`
  flex-basis: 100%;
  margin-top: 1rem;
`;

export const headerWrapperInnerCSS = css`
  width: 900px;
  max-width: 90dvw;
`;

export const kpiContentsWrapperCss = css`
  display: grid;
  justify-content: center;
  align-content: start;
  height: 90dvh;
  min-height: 100%;
  overflow-y: auto;
  padding: 2rem 2rem 3rem;
  &.small-screen {
    display: block;
    height: 100%;
    width: 100%;
    max-width: 100%;
    padding: 0;
    padding-inline: 1rem;
    & .inner-wrapper {
      width: 100%;
      max-width: 100%;
      padding: 0;
    }
  }
`;

export const kpiContentsInnerWrapperCss = css`
  display: grid;
  align-content: start;
  width: 900px;
  max-width: 90dvw;
  &&&&&& input,
  .MuiFormControl-root {
    margin: 0;
  }
`;
